import React from "react";
import { Mail, Phone } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { LOGO_URL, CONTACTS, whatsappLink } from "@/config";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            className="border-t border-[var(--fama-border)] bg-[var(--fama-bg)] py-16"
            data-testid="site-footer"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="grid grid-cols-1 gap-12 lg:grid-cols-3">
                    <div>
                        <img
                            src={LOGO_URL}
                            alt="FaMa Apartments"
                            className="h-20 w-auto"
                        />
                        <p className="mt-5 max-w-xs font-serif-display text-xl leading-snug text-[var(--fama-ink)]">
                            Il tuo immobile a Roma, gestito a 360°. Zero
                            pensieri, massima resa.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-body text-xs font-semibold uppercase tracking-[0.24em] text-[var(--fama-gold)]">
                            Contatti
                        </h4>
                        <ul className="mt-5 space-y-3 font-body text-sm text-[var(--fama-ink-soft)]">
                            <li className="flex items-center gap-3">
                                <Mail size={16} className="text-[var(--fama-gold)]" />
                                {CONTACTS.email}
                            </li>
                            <li className="flex items-center gap-3">
                                <WhatsAppIcon size={16} className="text-[var(--wa-green)]" />
                                <a
                                    href={whatsappLink()}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-whatsapp-primary"
                                    className="transition-colors hover:text-[var(--fama-ink)]"
                                >
                                    Matteo · {CONTACTS.whatsappPrimary} (nuovi contatti)
                                </a>
                            </li>
                            <li className="flex items-center gap-3">
                                <Phone size={16} className="text-[var(--fama-gold)]" />
                                Fabrizio · {CONTACTS.whatsappSecondary}
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-body text-xs font-semibold uppercase tracking-[0.24em] text-[var(--fama-gold)]">
                            Navigazione
                        </h4>
                        <ul className="mt-5 space-y-3 font-body text-sm text-[var(--fama-ink-soft)]">
                            {[
                                ["Chi siamo", "#chi-siamo"],
                                ["Servizi", "#servizi"],
                                ["Perché noi", "#perche-noi"],
                                ["Come funziona", "#come-funziona"],
                                ["Contatti", "#contatti"],
                            ].map(([label, href]) => (
                                <li key={href}>
                                    <a
                                        href={href}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            document
                                                .querySelector(href)
                                                ?.scrollIntoView({ behavior: "smooth" });
                                        }}
                                        className="transition-colors hover:text-[var(--fama-ink)]"
                                    >
                                        {label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-[var(--fama-border)] pt-6 sm:flex-row sm:items-center">
                    <p className="font-body text-xs text-[var(--fama-ink-soft)]">
                        © {year} FaMa Apartments. Tutti i diritti riservati.
                    </p>
                    <a
                        href="#"
                        data-testid="footer-privacy-link"
                        className="font-body text-xs text-[var(--fama-ink-soft)] underline underline-offset-4 transition-colors hover:text-[var(--fama-ink)]"
                    >
                        Privacy Policy
                    </a>
                </div>
            </div>
        </footer>
    );
}
